// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"2f579398","219":"d7b98adc","420":"c7dd7f7d","488":"62a4aef6","558":"abc10075","572":"eda417e2"}[chunkId] + ".chunk.js";
};